// eslint-disable-next-line
export const HISTORY_LOCAL_STORAGE_KEY = 'history';
